export const PersonalDetailsFieldErrors = {
  EmptyGender: 'Selection required',
  EmptyDOB: 'Please enter a valid date of birth',
  EmptyAddress: 'Address is required',
  EmptyTitle: 'Title is required',
  EmptyFirstName: 'First name is required',
  EmptyLastName: 'Last name is required',
  InvalidAddress: 'Invalid address. Select from dropdown or enter manually',
  EmptyEmergencyContactName: 'Emergency contact is required',
  EmptyEmergencyContactRelationship:
    'Emergency contact relationship is required',
  InvalidFirstName: 'First name is invalid',
  InvalidLastName: 'Last name is invalid',
  MobileNumberRequired: 'Mobile number is required',
  MobileNumberInvalid: 'Phone number is invalid',
};

export const BankDetailFieldErrors = {
  EmptyAccountName: 'Account name is required',
  EmptyBankName: 'Bank name is required',
  EmptySortCode: 'Sort code is required',
  InvalidSortCode: 'Sort code is invalid',
  EmptyAccountNumber: 'Account number is required',
  InvalidBSB: 'Invalid BSB number, try again',
};

export const SuperannuationFieldErrors = {
  EmptyOption: 'Please select one',
  UnknownInput: 'Invalid input',
  EmptyName: 'Name is required',
  EmptyTFN: 'Tax file number is required',
  InvalidTFN: 'Tax file number is invalid',
  EmptyFundName: 'Super fund is required',
  InvalidFundName: 'Invalid Super fund. Please select from dropdown',
  EmptyMemberNumber: 'Member number is required',
  EmptyDeclaration: 'This is required',
};

export const TFNDeclarationFieldErrors = {
  EmptyOption: 'Please select one',
  EmptyTFN: 'Tax file number is required',
  InvalidTFN: 'Tax file number is invalid',
  EmptyReason: 'Please select one',
  EmptyTitle: 'Please select one',
  EmptyName: 'Name is required',
  EmptyPayBasis: 'Please select one',
  EmptyResidentStatus: 'Please select one',
  EmptyCountryOfOrigin: 'Select a country of origin',
  EmptyTaxFreeTreshold: 'Please select one',
  EmptyHelpLoan: 'Please select one',
  EmptyDeclaration: 'This is required',
};

export const CustomQuestionsFieldErrors = {
  EmptyResponse: 'Answer required',
  EmptyChoiceResponse: 'Selection required',
  QuestionValueTypeError: 'Internal error',
};

export const WorkRightsFieldErrors = {
  EmptyResidency: 'Residency status is required',
  EmptyDocType: 'Document type is required',
  EmptyBirthCertificate: 'Birth certificate upload is required',
  EmptyPhotoId: 'Photo ID upload is required',
  EmptyPassportNumber: 'Passport number is required',
  EmptyCountryOfDocument: 'Country of document is required',
  EmptyTermsAndConditions: 'This is required',
  EmptyPassport: 'Passport upload is required',
  ExceedsFileSize: 'File size exceeds 10MB',
};
